// extracted by css-extract-rspack-plugin
export default {"wrapper":"FocusManagerWithArrowKeyNavigation-module__wrapper___T7j0g","skipElementWrapper":"FocusManagerWithArrowKeyNavigation-module__skipElementWrapper___llnxq"};